module.exports = __webpack_public_path__ + "img/mail_log_emt.b962f88e.png";